import { c as _c } from "react/compiler-runtime";
import { getErrorDisplayMarkup } from "@context-providers/error-boundary/error-boundary-utils";
import { setFetchingUpdatingProjects } from "@store/projects/projects-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { tableTypeSelector, updatingItemsSelector } from "@store/table/table-selector";
import { changeAllFetchingStatus, removeOneAfterFetching, removeOneManually, setBulkActionResults, updateOne } from "@store/table/table-slice";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";
/** Returns a function that loops over the selected entities and apply the provided bulkActionCallback to each entity */
export function useBulkActionCallback(t0) {
  const $ = _c(12);
  const {
    bulkActionCallback,
    onSuccessfulComplete,
    trackingEvent,
    selectedEntities,
    uniqueIdKey
  } = t0;
  const dispatch = useAppDispatch();
  const updatingItems = useAppSelector(updatingItemsSelector);
  const tableType = useAppSelector(tableTypeSelector);
  const {
    trackAsyncEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== bulkActionCallback || $[1] !== dispatch || $[2] !== onSuccessfulComplete || $[3] !== selectedEntities || $[4] !== tableType || $[5] !== trackAsyncEvent || $[6] !== trackingEvent || $[7] !== uniqueIdKey || $[8] !== updatingItems) {
    t1 = async () => {
      if (!tableType) {
        return;
      }
      await trackAsyncEvent({
        name: trackingEvent,
        props: {
          dataType: tableType,
          numberOfEntities: selectedEntities.length
        }
      });
      const bulkActionResults = {
        successIds: [],
        errorIds: []
      };
      dispatch(changeAllFetchingStatus({
        status: "in-queue",
        shouldClearMessage: true
      }));
      for (const entity of selectedEntities) {
        const entityId = entity[uniqueIdKey];
        if (typeof entityId !== "string") {
          throw new Error("entityId should be a string to accept it as correct type.");
        }
        const updatingItem = updatingItems.find(item => item.id === entityId);
        if (updatingItem?.status === "not-allowed") {
          dispatch(removeOneManually(updatingItem.id));
          continue;
        }
        dispatch(updateOne({
          id: entityId,
          changes: {
            status: "updating"
          }
        }));
        ;
        try {
          await bulkActionCallback(entity);
          dispatch(updateOne({
            id: entityId,
            changes: {
              status: "success"
            }
          }));
          bulkActionResults.successIds.push(entityId);
        } catch (t2) {
          const error = t2;
          dispatch(updateOne({
            id: entityId,
            changes: {
              status: "error",
              message: getErrorDisplayMarkup(error)
            }
          }));
          bulkActionResults.errorIds.push(entityId);
        }
      }
      dispatch(setBulkActionResults({
        numberOfSuccess: bulkActionResults.successIds.length,
        numberOfErrors: bulkActionResults.errorIds.length
      }));
      dispatch(setFetchingUpdatingProjects(false));
      if (bulkActionResults.errorIds.length > 0) {
        bulkActionResults.successIds.forEach(id => {
          dispatch(removeOneAfterFetching(id));
        });
        bulkActionResults.errorIds.forEach(id_0 => {
          dispatch(updateOne({
            id: id_0,
            changes: {
              status: "idle"
            }
          }));
        });
      }
      if (onSuccessfulComplete && bulkActionResults.errorIds.length === 0) {
        onSuccessfulComplete();
      }
    };
    $[0] = bulkActionCallback;
    $[1] = dispatch;
    $[2] = onSuccessfulComplete;
    $[3] = selectedEntities;
    $[4] = tableType;
    $[5] = trackAsyncEvent;
    $[6] = trackingEvent;
    $[7] = uniqueIdKey;
    $[8] = updatingItems;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const onBulkActionConfirmed = t1;
  let t2;
  if ($[10] !== onBulkActionConfirmed) {
    t2 = {
      onBulkActionConfirmed
    };
    $[10] = onBulkActionConfirmed;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}